<div
  class="email-png-preview-column flex h-full flex-col"
  [class.email-png-preview-column-new-application]="mode() == 'new-application'">
  <!-- Content -->
  <div class="min-h-0 flex-1">
    @if (hasFiles()) {
      <oiq-image-preview-zoom
        [attachments]="pngFiles()"
        [selectedFile]="selectedFile()"
        [enableZoom]="true"
        (fileSelected)="onFileSelected($event)"
        class="block h-full">
        <ng-template #headerRightTemplate>
          <div class="flex items-center gap-2">
            @if (mode() == 'email-preview') {
              <button
                class="oiq-button oiq-button--link p-0.5"
                type="button"
                title="Full View"
                (click)="onOpenFullView()">
                <i class="ph ph-arrows-out text-base leading-none"></i>
              </button>
            }
            <button
              class="oiq-button oiq-button--link __close p-0.5"
              type="button"
              (click)="onClosePreview()">
              <span class="material-symbols-outlined text-base leading-none">close</span>
            </button>
          </div>
        </ng-template>
      </oiq-image-preview-zoom>
    } @else {
      <div class="relative flex h-full items-center justify-center p-4">
        <button
          class="oiq-button oiq-button--link __close absolute right-2 top-2 p-0.5"
          type="button"
          (click)="onClosePreview()">
          <span class="material-symbols-outlined text-base leading-none">close</span>
        </button>
        <div class="text-center text-gray-500">
          <div class="mb-3">
            <span class="material-symbols-outlined text-4xl text-gray-300">image</span>
          </div>
          <p class="text-sm">No preview available</p>
          <p class="mt-1 text-xs text-gray-400">Process a PDF attachment to see preview</p>
        </div>
      </div>
    }
  </div>
</div>
